import React from "react";
import "./preloader.css";

const Preloader = () => {
  return (
    <div className="preloader-container">
      <div className="simple-container">
        <div className="simple-image blink-1">
          <img src="./assets/accent-logo.svg" alt="" />
        </div>
      </div>
    </div>
  );
};

export default Preloader;
